import styled from 'styled-components';

// Flex-column layout for config pages that stack header + status tabs + table.
// It lets the table fill the remaining space and scroll internally, instead of
// relying on a fixed pixel offset that doesn't account for the tabs row.
// Flex-column box for config pages. Height is set at runtime by the
// ConfigTableLayout component (measures its own top offset and fills to the
// viewport bottom) because the Semantic-UI Sidebar.Pushable ancestor has no
// height:100%, so a percentage-height chain collapses and the table would grow
// unbounded / get clipped with no scrollbar.
export const ConfigTableLayoutBox = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  /* When rendered inside a flex column (ConfigTableLayout) the table fills the
     leftover space; the height fallback below applies for non-flex parents. */
  flex: 1;
  min-height: 0;
  height: calc(100% - 83px);
  overflow: auto;
  border: none !important;
  .ui.sortable.table thead th.sorted {
    background: #f9fafb;
  }
  .ui.table {
    border: none !important;
  }
  .ui.table thead tr:first-child > th {
    position: sticky;
    top: 0;
    z-index: 2;
    border-top: 1px solid #c9cfd3;
  }
`;
